import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '~/redux/store'
import { StoryCardId } from '~/types/storyCard'

interface StoryCardState {
  id: StoryCardId | null
}

const initialState: StoryCardState = {
  id: null,
}

const slice = createSlice({
  name: 'story-card',
  initialState,
  reducers: {
    setStoryCardId: (state, action: PayloadAction<StoryCardId>) => ({
      ...state,
      id: action.payload,
    }),

    resetStoryCardId: (state) => ({
      ...state,
      id: null,
    }),
  },
})

export const selectStoryCardId = (state: RootState): StoryCardState['id'] => {
  return state.storyCard.id
}

export const { setStoryCardId: setStoryCardIdActionCreator, resetStoryCardId: resetStoryCardIdActionCreator } =
  slice.actions

export default slice.reducer
